import { Observable } from "rxjs";
import * as Graph from "src/app/services/api/savings-and-pension-queries.types";
import { Nullable } from "src/app/utils/utils";
import { EngagementName, EngagementSimulationStatus } from "../../pension.model";
import { SavingsAndPensionEngagement } from "./savings-and-pension-engagement.model";
import { getSimulationStatus } from "../graph-engagement.model";
import { InsuranceCoverage } from "src/app/services/api/savings-and-pension-queries.types";
type Contract =
  | Graph.EpkContract
  | Graph.EpkFleksibelContract
  | Graph.EpkFleksibelPkbContract
  | Graph.EpkEmploymentContract;

export abstract class AbstractEpkEngagement<TContract extends Contract> extends SavingsAndPensionEngagement<TContract> {
  /** @deprecated Use getNameAsync instead */
  public getName(): EngagementName {
    return this.getDefaultName(this.contract);
  }

  public getNameAsync(): Observable<EngagementName> {
    return this.getDefaultNameAsync(this.contract);
  }

  public getContractNumberCustomer(): Nullable<string> {
    return this.contract?.customerContractReference;
  }

  public getContractNumber(): Nullable<string> {
    return this.contract?.contractNumber;
  }

  public isSavingsEngagement(): boolean {
    return false;
  }

  public isActive(): boolean {
    return true;
  }

  public getEmployerOrganisationNumber(): Nullable<string> {
    return undefined;
  }

  public override getInsuranceCoverages(): Nullable<InsuranceCoverage[]> {
    return this.contract?.coverages?.insuranceCoverages;
  }
}

export class EpkEngagement extends AbstractEpkEngagement<Graph.EpkContract> {
  public getAllocationCode(): Nullable<string> {
    return this.contract?.allocationCode;
  }
  public override getEmployerOrganisationNumber(): Nullable<string> {
    return this.contract?.employer?.organizationNumber;
  }

  public override getCustomerPersonStatus(): Nullable<string> {
    return this.contract?.personStatus;
  }
}
export class EpkFleksibelEngagement extends AbstractEpkEngagement<Graph.EpkFleksibelContract> {
  public getAllocationCode(): Nullable<string> {
    return this.contract?.allocationCode;
  }

  public override getEPKEmploymentContract(): Nullable<Graph.EpkEmploymentContract> {
    return this.contract?.epkEmploymentContract;
  }

  public override getAnnualDepositAndCompensation(): Nullable<number> {
    return this.contract?.annualDepositAndCompensation;
  }

  public override getSimulationStatus(): EngagementSimulationStatus[] {
    // If there is an error about consent not given AND there is an employment contract, do not show the error
    const hasErrorAboutConsentNotGivenAndEmploymentContract =
      this.contract?.epkEmploymentContract &&
      getSimulationStatus(this.prognosis?.simulationStatus).severity === Graph.SimulationSeverity.ConsentNotGiven;

    return hasErrorAboutConsentNotGivenAndEmploymentContract
      ? []
      : [getSimulationStatus(this.prognosis?.simulationStatus)];
  }

  public override getEmployerOrganisationNumber(): Nullable<string> {
    return this.getEPKEmploymentContract()?.employer?.organizationNumber;
  }

  public override getCustomerPersonStatus(): Nullable<string> {
    return this.getEPKEmploymentContract()?.personStatus;
  }

  public override getInsuranceCoverages(): Nullable<InsuranceCoverage[]> {
    return this.getEPKEmploymentContract()?.coverages?.insuranceCoverages;
  }
}
export class EpkEmploymentEngagement extends AbstractEpkEngagement<Graph.EpkEmploymentContract> {
  public getAllocationCode(): Nullable<string> {
    return undefined;
  }

  public override getEmployerOrganisationNumber(): Nullable<string> {
    return this.contract?.employer?.organizationNumber;
  }

  public override getEmployerName(): Nullable<string> {
    return this.contract?.employer?.name;
  }

  public override getEpkFleksibelContractId(): Nullable<string> {
    return this.contract?.epkFleksibelContractId;
  }

  public override getCustomerPersonStatus(): Nullable<string> {
    return this.contract?.personStatus;
  }
}
